var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCalendar2 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 40 40"
}, props), /*#__PURE__*/React.createElement("mask", {
  id: "calendar2_svg__a",
  width: 40,
  height: 40,
  x: 0,
  y: 0,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "alpha"
  }
}, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M0 0h40v40H0z"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#calendar2_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M17.889 23.6v-3.1h3.222v3.1H17.89Zm-6.445 0v-3.1h3.223v3.1h-3.223Zm12.89 0v-3.1h3.222v3.1h-3.223Zm-6.445 6.2v-3.1h3.222v3.1H17.89Zm-6.445 0v-3.1h3.223v3.1h-3.223Zm12.89 0v-3.1h3.222v3.1h-3.223ZM5 36V8.1h4.833V5h3.223v3.1h12.888V5h3.223v3.1H34V36H5Zm3.222-3.1h22.556V17.4H8.222v15.5Zm0-18.6h22.556v-3.1H8.222v3.1Z"
}))));
export default SvgCalendar2;